import { defineStore } from 'pinia'
import iconConfig from '@/components/icon/iconConfig.json'

export const useIconStore = defineStore('icon', () => {
  const aliases = new Map(Object.entries(iconConfig.aliases))

  function getIcon(name: string) {
    if (!aliases.has(name)) {
      console.warn('Icon not found:', name)
      return
    }

    return aliases.get(name)
  }

  return {
    getIcon
  }
})
